import { PdAssistantInputBar } from "./pd-assistant-input-bar/PdAssistantInputBar.js";
//#region src/pd-assistant-input-bar/pd-assistant-input-bar.ts
var tag = "pd-assistant-input-bar";
if (!customElements.get(tag)) customElements.define(tag, PdAssistantInputBar);
//#endregion
export { PdAssistantInputBar };
